import type { BlockCMS, Product } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { Tab } from '@headlessui/react'
import { Fragment, useState } from 'react'
import { Autoplay, FreeMode, Grid, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import ProductCard from '../ProductCard'

interface ModuleProductTabType {
  data: BlockCMS
}
const ModuleProductTab = ({ data }: ModuleProductTabType) => {
  const bgColorArray = data.data.map(e => e?.color)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [showItem, setShowItem] = useState(4)

  return (
    <section
      id={data._id}
      className={`${data?.type} ${
        data?.hideBot ? '' : 'pb-3'
      } scroll-mt-[150px] bg-white rounded-sm mx-2`}
    >
      <Tab.Group
        as='div'
        onChange={index => {
          setSelectedIndex(index)
          setShowItem(4)
        }}
        selectedIndex={selectedIndex}
        className={`mb-3 block `}
      >
        <Tab.List
          as='div'
          className={`hiddenScrollBar w-full overflow-x-auto pb-2`}
        >
          <div className='flex w-full gap-2 border-b border-[#E5E5E5]'>
            {data &&
              data.data.map((list, idx) => {
                return (
                  <Tab as={Fragment} key={idx}>
                    {({ selected }) => (
                      <button
                        className={`flex flex-col flex-wrap items-center justify-center pt-4 pb-2 px-5 ${
                          selected
                            ? 'border-b-[3px] border-redPico font-bold text-redPico'
                            : ''
                        } `}
                      >
                        <span>{getTranslate(list.name)}</span>
                      </button>
                    )}
                  </Tab>
                )
              })}
          </div>
        </Tab.List>
        <Tab.Panels
          as='div'
          className={`py-3`}
          style={{ backgroundColor: bgColorArray[selectedIndex] }}
        >
          {data &&
            data.data.map((list, idx) => {
              return (
                <Tab.Panel key={idx}>
                  <div className='flash-sale--content'>
                    {list?.products?.length >= 4 ? (
                      <Swiper
                        modules={[Grid, FreeMode, Autoplay, Navigation]}
                        className='flashSaleSwp'
                        slidesPerView={2}
                        grid={{
                          rows: 20,
                          fill: 'row',
                        }}
                        slidesPerGroup={2}
                        freeMode={true}
                        spaceBetween={8}
                        autoplay={false}
                        speed={400}
                      >
                        {list?.products
                          ?.slice(0, showItem)
                          .map((product: Product, idx: number) => (
                            <SwiperSlide key={product._id + idx + 'fs'}>
                              <ProductCard
                                product={product}
                                type='cms'
                                layout={2}
                                className='flashSaleSlider'
                              />
                            </SwiperSlide>
                          ))}
                      </Swiper>
                    ) : (
                      <div className='max-w-screen grid grid-cols-2 gap-2 px-2'>
                        {list?.products?.map(
                          (product: Product, idx: number) => (
                            <ProductCard
                              key={product._id + idx + 'fs'}
                              product={product}
                              type='cms'
                              layout={2}
                              className=''
                            />
                          )
                        )}
                      </div>
                    )}
                  </div>
                  {list && list?.products.length > 4 && (
                    <div
                      className='w-full pt-2 cursor-pointer text-redPico text-center font-semibold'
                      onClick={() =>
                        setShowItem(showItem == 4 ? list?.products.length : 4)
                      }
                    >
                      {showItem === 4 ? 'Xem thêm sản phẩm >>>' : 'Thu gọn'}
                    </div>
                  )}
                </Tab.Panel>
              )
            })}
        </Tab.Panels>
      </Tab.Group>
    </section>
  )
}

export default ModuleProductTab
